import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import type React from 'react';

type Severity = 'success' | 'error' | 'warning' | 'info';

const TINT: Record<Severity, string> = {
  success: 'rgba(237,247,237,0.92)',
  error: 'rgba(253,237,237,0.92)',
  warning: 'rgba(255,244,229,0.92)',
  info: 'rgba(229,246,253,0.92)',
};

const BORDER: Record<Severity, string> = {
  success: 'rgba(46,125,50,0.35)',
  error: 'rgba(211,47,47,0.35)',
  warning: 'rgba(237,108,2,0.35)',
  info: 'rgba(2,136,209,0.35)',
};

const ICON_COLOR: Record<Severity, string> = {
  success: 'success.dark',
  error: 'error.dark',
  warning: 'warning.dark',
  info: 'info.dark',
};

interface Props {
  open: boolean;
  onClose: () => void;
  message: string;
  severity?: Severity;
  autoHideDuration?: number;
}

const FeedbackSnackbar: React.FC<Props> = ({
  open,
  onClose,
  message,
  severity = 'success',
  autoHideDuration = 2500,
}) => (
  <Snackbar
    open={open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
  >
    <Alert
      severity={severity}
      variant="outlined"
      onClose={onClose}
      sx={{
        bgcolor: TINT[severity],
        backdropFilter: 'blur(16px)',
        boxShadow: '0px 12px 32px rgba(21, 24, 58, 0.10)',
        borderColor: BORDER[severity],
        '& .MuiAlert-icon': { color: ICON_COLOR[severity] },
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: 'text.primary',
        }}
      >
        {message}
      </Typography>
    </Alert>
  </Snackbar>
);

export default FeedbackSnackbar;
